'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'mug-saucer';
var width = 576;
var height = 512;
var aliases = ["coffee"];
var unicode = 'f0f4';
var svgPathData = 'M64 32l384 0c70.7 0 128 57.3 128 128S518.7 288 448 288l0 96-384 0 0-352zM512 160c0-35.3-28.7-64-64-64l0 128c35.3 0 64-28.7 64-64zM64 448l416 0 0 64-448 0 0-64 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugSaucer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;